export class ArticleDetailData{
    id: string;
    title: string;
    description: string;
    descriptionWeb: string;
    person: string;
    institution: string;
    tags: string;
    image: Image;
    start: Date;
    end: Date;
    relatedArticles: RelatedArticle[];
}

export class RelatedArticle {
    id: string;
    title: string;
    createdBy: string;
    start: Date;
    end: Date;
    createdDate: Date;
    imageUrl: string;
    image: Image;
}

export class Image {
    image_web: string;
    image_mobile: string;
}
